const angular = require('angular')
require('./avatarDirectives')
/* Directives */
module.exports = angular.module('hxphone.avatarDirectives', []).directive('avatar', ['$location', '$utils', 'User', '$rootScope',
  function ($location, $utils, User, $rootScope) {
    return {
      replace: true,
      restrict: 'AE',
      // todo: 确认指令内的scope变量要全小写才能生效
      scope: {
        contactinfo: '='
      },
      template: function () {
        if ($rootScope.settings.useGeneralAvatar) {
          return "<div class='generalAvatar' style='background:{{generalAvatar.color}};'>{{generalAvatar.text}}</div>"
        } else {
          return "<img ng-src='{{ url }}' src='" + require('assets/img/header.png') + "' />"
        }
      },
      link: function (scope) {
        const currentUser = User.getCurrentUser()
        // 监听contactinfo变化用于加载头像
        scope.$watch(function () {
          return scope.contactinfo
        }, function (value) {
          loadAvatar(value)
        })
        // 加载头像
        function loadAvatar(contactInfo) {
          if (!contactInfo) {
            return
          }
          if ($rootScope.settings.useGeneralAvatar) {
            // 使用通用头像
            scope.generalAvatar = getAvatarColorAndText(contactInfo.addr || contactInfo.email, contactInfo.name)
          } else {
            if (contactInfo.type === 'pabContact') {
              // 个人通讯录联系人头像
              const uid = contactInfo.id
              currentUser.simpleCall({
                query: {
                  func: 'pab:hasHeadImage',
                  sid: currentUser.sid
                },
                data: {
                  uid: uid
                }
              }).then(function (data) {
                if (data.code === 'S_OK' && data.var == 1) { // 该联系人有头像
                  const img = new Image()
                  const url = currentUser.wmsvrClient.getRequestURL({
                    query: {
                      func: 'pab:getContactAvatar',
                      sid: currentUser.sid,
                      uid: uid,
                      time: Date.now()
                    }
                  })
                  img.src = url
                  img.onload = function () {
                    scope.url = url
                    scope.$digest()
                  }
                } else {
                }
              }, function (error) {
                console.log(error)
              })
            } else {
              // 组织通讯录联系人头像
              const email = contactInfo.from || contactInfo.addr || contactInfo.email
              const emailAddr = $utils.$email.parse(email)
              const uid = emailAddr.addr
              const img = new Image()
              const url = currentUser.wmsvrClient.getRequestURL({
                query: {
                  func: 'oab:getHeadImageData',
                  sid: currentUser.sid,
                  uid: uid
                }
              })
              img.src = url
              img.onload = function () {
                scope.url = url
                scope.$digest()
              }
            }
          }
        }
        // 获取通用头像颜色和头像文字
        function getAvatarColorAndText(email, name) {
          const colorList = $rootScope.settings.avatarColors
          const generalAvatarTextMatchRule = $rootScope.settings.generalAvatarTextMatchRule
          let color = colorList[0]
          let text = ''
          const emailCharList = email && email.split('')
          if (emailCharList && emailCharList.length >= 2) {
            text = emailCharList[0] + emailCharList[1]
          }
          if (email) {
            color = getColorByEmail(email, colorList)
          }
          if (name) {
            // 头像文字的生成规则分两步，特定规则匹配和通用规则匹配
            const chinesePart = name.match(/[\u4e00-\u9fa5]+/ig)
            const otherLanguagePart = name.match(/\w+/ig)
            let temp = ''
            if ($rootScope.settings.useGeneralAvatarTextRule) {
              let sMatchResult = ''
              sMatchResult = getTextBySpecificRuleMatch(name, generalAvatarTextMatchRule)
              if (!sMatchResult) {
                if (chinesePart) {
                  temp = getTextByGeneralRuleMatch(chinesePart)
                } else if (otherLanguagePart) {
                  temp = getTextByGeneralRuleMatch(otherLanguagePart)
                }
              } else {
                temp = sMatchResult.result
              }
            } else {
              if (chinesePart) {
                temp = getTextByGeneralRuleMatch(chinesePart)
              } else if (otherLanguagePart) {
                temp = getTextByGeneralRuleMatch(otherLanguagePart)
              }
            }
            if (temp) {
              text = temp
            }
          }
          // 根据email字符编码和得到唯一数字标识，通过取模获取唯一对应颜色值
          function getColorByEmail(email, colorList) {
            const emailCharList = email.split('')
            let charCodeNum = 0
            let colorIndex = 0
            emailCharList.forEach(function (item) {
              charCodeNum = charCodeNum + item.charCodeAt(0)
            })
            colorIndex = charCodeNum % 7
            return colorList[colorIndex]
          }
          // 特定规则匹配，根据配置文件的规则对象匹配获取文字
          function getTextBySpecificRuleMatch(str, rulesObject) {
            let temp = null
            let result = null
            let priority = null
            Object.keys(rulesObject).forEach(function (item) {
              if (str.indexOf(item) !== -1) {
                if (result && priority) {
                  if (rulesObject[item].priority > priority) {
                    priority = rulesObject[item].priority
                    result = rulesObject[item].value
                  }
                } else {
                  result = rulesObject[item].value
                  priority = rulesObject[item].priority
                }
              }
            })
            if (result) temp = {result: result, priority: priority}
            return temp
          }
          // 通用规则配置，使用通用规则匹配获取文字
          function getTextByGeneralRuleMatch(strArr) {
            let result = null
            const nameCharList = strArr[0].split('')
            if (nameCharList.length >= 2) {
              result = nameCharList[nameCharList.length - 2] + nameCharList[nameCharList.length - 1]
            } else {
              result = nameCharList[nameCharList.length - 1]
            }
            return result
          }
          return { color: color, text: text }
        }
      }
    }
  }])



// WEBPACK FOOTER //
// ./src/js/addressbook/organizational/detail/avatarDirectives.js